import { render } from "./Monitoring.vue?vue&type=template&id=0c6c7826&scoped=true"
import script from "./Monitoring.vue?vue&type=script&lang=js"
export * from "./Monitoring.vue?vue&type=script&lang=js"

import "./Monitoring.vue?vue&type=style&index=0&id=0c6c7826&lang=css"
import "./Monitoring.vue?vue&type=style&index=1&id=0c6c7826&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6c7826"]])

export default __exports__